import moment from "moment";
import QRCode from 'qrcode'


let threshold, touchend;
const handleScroll = () => {
    const { scrollTop, scrollHeight } = document.documentElement;
    const height = window.innerHeight;

    if (scrollTop + height >= scrollHeight - threshold) {
        if (touchend) touchend();
    }
}



const utils = {
    //
    windowScrollTouchend({ threshold = 1, touchend }) {
        threshold = threshold;
        touchend = touchend;
        window.addEventListener('scroll', handleScroll);
    },
    destroyScrollTouchend() {
        window.removeEventListener('scroll', handleScroll);
    },
    dateFormat(date, format) {
        //$moment(new Date(item.eventTime.start)).format()
        if (date) {
            return moment(date).format(format);
        }
        return '';
    },
    async generateQRCode(inputText) {
        if (!inputText.trim()) {
            throw new Error('請輸入文本');
        }

        try {
            
            return await QRCode.toDataURL(inputText, {
                width: 200,       
                margin: 2,        
                color: {
                    dark: '#000000',  
                    light: '#ffffff'  
                }
            })
        } catch (error) {
            throw error;
        }
    },

    getCurrentPosition() {
        return new Promise((resolve, reject) => {
            // 瀏覽器定位檢測
            if (!navigator.geolocation) {
                reject(new Error("您的瀏覽器不支持定位功能"));
                return;
            }

            const success = (loc) => {
                const location = {
                    latitude: loc.coords.latitude, 
                    longitude: loc.coords.longitude, 
                    accuracy: loc.coords.accuracy, 
                };
                resolve(location);
            };

            const error = (err) => {
                var errorType = [
                    "請先打開瀏覽器位置資訊的權限！",
                    "獲取不到位置信息！",
                    "獲取位置信息超時！",
                ];
                reject(new Error(errorType[err.code - 1]));
            };


            // 獲取當前位置
            navigator.geolocation.getCurrentPosition(success, error,
                {
                    enableHighAccuracy: true, 
                    timeout: 5000,            
                    maximumAge: 0             
                }
            )
        });
    },
}

export default utils